import React from 'react';

import { Button, Paper, createStyles, useMantineTheme, TextInput, ActionIcon, Space } from '@mantine/core';
import { IconPlus, IconSearch, IconX } from '@tabler/icons-react';

const useStyles = createStyles(theme => ({
  header: {
    width: '100%',
    padding: theme.spacing.xs,
    display: 'flex',
    gap: theme.spacing.xs,
    background: theme.colors.gray[0],
  },
}));

interface FilterTerms {
  searchTerm: string;
  isArrangeByLastName: boolean;
  athleteStatus: string;
  packages: string[];
  loginEnabled: string;
  hasPaymentMethod: string;
  hasSignedWaiver: string;
}

const AthletesPageHeader = ({
  searchFilters,
  setSearchFilters,
  handleOpenFilters,
  handleOpenCreateForm,
  permission = true,
}: {
  searchFilters: FilterTerms;
  setSearchFilters: React.Dispatch<React.SetStateAction<FilterTerms>>;
  handleOpenFilters: () => void;
  handleOpenCreateForm: () => void;
  permission?: boolean;
}): JSX.Element => {
  const theme = useMantineTheme();
  const { classes } = useStyles();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget?.value || '';
    setSearchFilters(prevValue => ({ ...prevValue, searchTerm: value }));
  };
  const handleClearSearchFilter = (): void => {
    setSearchFilters(prevValue => ({ ...prevValue, searchTerm: '' }));
  };

  return (
    <Paper className={classes.header}>
      <Button
        leftIcon={<IconPlus size={theme.fontSizes.md} />}
        onClick={handleOpenCreateForm}
        disabled={!permission}
      >
        Athlete
      </Button>
      <Button onClick={handleOpenFilters} disabled={!permission}>
        Filters
      </Button>
      <TextInput
        sx={{ flexGrow: 1 }}
        icon={<IconSearch size={theme.fontSizes.md} />}
        placeholder='Search by name, email, phone'
        value={searchFilters?.searchTerm}
        onChange={handleSearchChange}
        rightSection={
          !!searchFilters.searchTerm ? (
            <ActionIcon onClick={handleClearSearchFilter} size='md'>
              <IconX size={theme.fontSizes.md} />
            </ActionIcon>
          ) : (
            <Space />
          )
        }
      />
    </Paper>
  );
};

export default AthletesPageHeader;
